import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { IResourceName } from 'volta/models/base-model';
import Task, { TaskEvents } from 'volta/models/task';
import EventStreamService from 'volta/services/event-stream';

interface IArgs {
  resourceName: IResourceName;
  comments: Record<string, Task[]>;
  entityId: string;
  isLoading?: boolean;
  disabled?: boolean;
  commentsReadonly?: boolean;
  showFullDate?: boolean;
  onDelete?: (task: Task) => void;
  onCommentCreated: () => void;
  onCommentDeleted: () => void;
}

export default class CommentList extends Component<IArgs> {
  @service eventStream!: EventStreamService;

  get comments() {
    return Object.entries(this.args.comments).map(([groupId, value]) => {
      return {
        groupId,
        comments: value
      };
    });
  }

  constructor(owner: any, args: IArgs) {
    super(owner, args);

    if (!this.args.resourceName) {
      return;
    }

    this.eventStream.addHandler(
      this.args.resourceName.plural,
      TaskEvents.TaskCreated,
      this.args.onCommentCreated,
      this
    );

    this.eventStream.addHandler(
      this.args.resourceName.plural,
      TaskEvents.TaskDeleted,
      this.args.onCommentDeleted,
      this
    );
  }

  willDestroy() {
    this.eventStream.removeHandlers(this);
  }
}
